import { createComponent } from '@carvana/merch-components';
import { CommonModuleInner } from '../styles';

export const InnerWrapper = createComponent(CommonModuleInner, {
  className: 'l:max-h-[700px] l:flex-row l:gap-80'
});

export const ImageWrapper = createComponent('div', {
  className: 'h-[335px] w-full max-w-[450px] l:order-1 l:h-auto l:max-w-[532px]'
});
